"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentEditCreditLimitEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const Field_1 = require("../../../Form/Field");
const utils_1 = require("../utils");
const AgentEditCreditLimitEditor = (props) => {
    const { fields } = props;
    if (fields.creditLimitTotalAmount.hidden)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__field` },
        react_1.default.createElement(Field_1.FormField, { addon: 'CHF', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Agent/Edit:CreditLimit', defaultMessage: 'Credit limit' }), name: 'creditLimitTotalAmount', error: fields.creditLimitTotalAmount.error, value: (0, utils_1.wrapNumericValue)(fields.creditLimitTotalAmount.value), onChange: (0, utils_1.wrapNumericOnEvent)(fields.creditLimitTotalAmount.onEvent), modificators: fields.creditLimitTotalAmount.modifiers, disabled: fields.creditLimitTotalAmount.disabled })));
};
exports.AgentEditCreditLimitEditor = AgentEditCreditLimitEditor;
//# sourceMappingURL=creditLimit.js.map